export const PRODUCER_DEFAULTS_ERROR_MSG = `There was a problem loading your defaults. Please reload to try
again.`;
export const PRODUCER_DEFAULTS_TITLE_MSG = `These defaults will apply to quotes you start with Fast Premium.`;
